import { render, staticRenderFns } from "./SuccessText.vue?vue&type=template&id=200df645&scoped=true"
import script from "./SuccessText.vue?vue&type=script&lang=js"
export * from "./SuccessText.vue?vue&type=script&lang=js"
import style0 from "./SuccessText.vue?vue&type=style&index=0&id=200df645&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200df645",
  null
  
)

export default component.exports